'use client' // Error components must be Client components

import Error from '@/components/Error'
import WithErrorPageLayout from '@/helpers/WithErrorPageLayout'

const PageError = WithErrorPageLayout(Error)

export default PageError
